import each from './each'

export default {
  init () {},
  res: null,
  errorHandler (error) {
    const h = this.$createElement
    let errors = []

    if (error.body && error.status !== 500) {
      if(error.status !== 401) {
        each(error.body, (item, key) => {
          if (item.constructor === Array) {
            each(item, (subItem) => {
              errors.push(h('div', JSON.stringify(subItem)))
            })
          } else {
              errors.push(h('div', item))
          }
        })
      }
    } else {
      errors.push(h('div', 'Ops something went wrong'))
    }

    if(errors.length > 0){
      this.$notify.error({
        title: 'Error',
        duration: 15000,
        message: h('div', errors)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/api.js